import { render, staticRenderFns } from "./acceptanceTimeout.vue?vue&type=template&id=22bcc140"
import script from "./acceptanceTimeout.vue?vue&type=script&lang=js"
export * from "./acceptanceTimeout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports